/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createStressAreaGroup } from '../fn/stress-area-group-controller/create-stress-area-group';
import { CreateStressAreaGroup$Params } from '../fn/stress-area-group-controller/create-stress-area-group';
import { deleteStressAreaGroup } from '../fn/stress-area-group-controller/delete-stress-area-group';
import { DeleteStressAreaGroup$Params } from '../fn/stress-area-group-controller/delete-stress-area-group';
import { getStressAreaGroup } from '../fn/stress-area-group-controller/get-stress-area-group';
import { GetStressAreaGroup$Params } from '../fn/stress-area-group-controller/get-stress-area-group';
import { getStressAreaGroups } from '../fn/stress-area-group-controller/get-stress-area-groups';
import { GetStressAreaGroups$Params } from '../fn/stress-area-group-controller/get-stress-area-groups';
import { getStressAreaGroupsFiltered } from '../fn/stress-area-group-controller/get-stress-area-groups-filtered';
import { GetStressAreaGroupsFiltered$Params } from '../fn/stress-area-group-controller/get-stress-area-groups-filtered';
import { PageStressAreaGroupDto } from '../models/page-stress-area-group-dto';
import { StressAreaGroupDto } from '../models/stress-area-group-dto';
import { updateStressAreaGroup } from '../fn/stress-area-group-controller/update-stress-area-group';
import { UpdateStressAreaGroup$Params } from '../fn/stress-area-group-controller/update-stress-area-group';

@Injectable({ providedIn: 'root' })
export class StressAreaGroupControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getStressAreaGroup()` */
  static readonly GetStressAreaGroupPath = '/v1/stressareagroup/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStressAreaGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStressAreaGroup$Response(params: GetStressAreaGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<StressAreaGroupDto>> {
    return getStressAreaGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStressAreaGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStressAreaGroup(params: GetStressAreaGroup$Params, context?: HttpContext): Observable<StressAreaGroupDto> {
    return this.getStressAreaGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<StressAreaGroupDto>): StressAreaGroupDto => r.body)
    );
  }

  /** Path part for operation `updateStressAreaGroup()` */
  static readonly UpdateStressAreaGroupPath = '/v1/stressareagroup/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStressAreaGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStressAreaGroup$Response(params: UpdateStressAreaGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<StressAreaGroupDto>> {
    return updateStressAreaGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStressAreaGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStressAreaGroup(params: UpdateStressAreaGroup$Params, context?: HttpContext): Observable<StressAreaGroupDto> {
    return this.updateStressAreaGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<StressAreaGroupDto>): StressAreaGroupDto => r.body)
    );
  }

  /** Path part for operation `deleteStressAreaGroup()` */
  static readonly DeleteStressAreaGroupPath = '/v1/stressareagroup/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteStressAreaGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStressAreaGroup$Response(params: DeleteStressAreaGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteStressAreaGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteStressAreaGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStressAreaGroup(params: DeleteStressAreaGroup$Params, context?: HttpContext): Observable<void> {
    return this.deleteStressAreaGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getStressAreaGroups()` */
  static readonly GetStressAreaGroupsPath = '/v1/stressareagroup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStressAreaGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStressAreaGroups$Response(params?: GetStressAreaGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<PageStressAreaGroupDto>> {
    return getStressAreaGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStressAreaGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStressAreaGroups(params?: GetStressAreaGroups$Params, context?: HttpContext): Observable<PageStressAreaGroupDto> {
    return this.getStressAreaGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageStressAreaGroupDto>): PageStressAreaGroupDto => r.body)
    );
  }

  /** Path part for operation `createStressAreaGroup()` */
  static readonly CreateStressAreaGroupPath = '/v1/stressareagroup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createStressAreaGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStressAreaGroup$Response(params: CreateStressAreaGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<StressAreaGroupDto>> {
    return createStressAreaGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createStressAreaGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStressAreaGroup(params: CreateStressAreaGroup$Params, context?: HttpContext): Observable<StressAreaGroupDto> {
    return this.createStressAreaGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<StressAreaGroupDto>): StressAreaGroupDto => r.body)
    );
  }

  /** Path part for operation `getStressAreaGroupsFiltered()` */
  static readonly GetStressAreaGroupsFilteredPath = '/v1/stressareagroup/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStressAreaGroupsFiltered()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getStressAreaGroupsFiltered$Response(params: GetStressAreaGroupsFiltered$Params, context?: HttpContext): Observable<StrictHttpResponse<PageStressAreaGroupDto>> {
    return getStressAreaGroupsFiltered(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStressAreaGroupsFiltered$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getStressAreaGroupsFiltered(params: GetStressAreaGroupsFiltered$Params, context?: HttpContext): Observable<PageStressAreaGroupDto> {
    return this.getStressAreaGroupsFiltered$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageStressAreaGroupDto>): PageStressAreaGroupDto => r.body)
    );
  }

}
